"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Max Group Size',
  isRelevant: function isRelevant(styleParams) {
    return true;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  min: 0,
  max: 3,
  "default": 3,
  description: "Choose the max number of items grouping in the gallery, \"1\" for only one items per group and \"3\"(max) for up to 3 item per group.\n  "
};
exports["default"] = _default;